import _ from 'lodash';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import SignaturePad from "react-signature-canvas";
import { getUserProfile } from './formSlice';

function SignatureComponent(props) {
  const dispatch = useDispatch();
  const { schema, value, onChange, required } = props;
  const { userRole } = schema;
  const [signPad, setSignPad] = useState({});
  const [isClear, setIsClear] = useState(false);

  const { role } = useSelector(state => state.form);

  function getSignature() {
    dispatch(getUserProfile({
      token: localStorage.getItem("authToken"),
      role: userRole
    }))
  }

  function clear() {
    onChange();
  };

  function updateValue() {
    let url = signPad.getTrimmedCanvas().toDataURL("image/png");
    onChange(url);
  }

  function clearInformation(type) {
    clear();
    setIsClear(true);

    try {
      let selector = '.container .rjsf .form-group .container-fluid:last-child';
      let informationSection = [...document.querySelectorAll(selector)];
      
      if(type == 'clinician') {
        informationSection = informationSection[informationSection.length - 2];
      } else {
        informationSection = informationSection[informationSection.length - 1];
      }
      if(informationSection){
        informationSection.classList.add(`${type}-part`);
        document.querySelector(`.${type}-part #prn_date`).value = '';
        document.querySelector(`.${type}-part #prn_date`).removeAttribute('readonly');
        document.querySelector(`.${type}-part #prn_date`).placeholder = 'mm/dd/yyyy';

        document.querySelector(`.${type}-part #prn_name`).value = '';
        document.querySelector(`.${type}-part #prn_name`).removeAttribute('readonly');
        document.querySelector(`.${type}-part #prn_name`).placeholder = 'Name, Degree, Credentials';
      }
    } catch (error) {
      console.error("Somthing went wrong, refresh and try again");
    }
  }

  function renderSignature() {
    if(isClear === true) {
      return (
        <React.Fragment>
          <div className="canvas">
            <SignaturePad
                  canvasProps={{ className: '' }}
                  ref={(ref) => {
                    setSignPad(ref);
                  }}
                  onEnd={updateValue}
                />
            </div>
        </React.Fragment>
      )
    }
    else if (role === 'client') {
      return (
        <React.Fragment>
          <div className="canvas">
            {_.isEmpty(value) ?
              <SignaturePad
                canvasProps={{ className: '' }}
                ref={(ref) => {
                  setSignPad(ref);
                }}
                onEnd={updateValue}
              /> : <img src={value} alt="" />
            }
          </div>
          <button type="button" className="btn btn-secondary btn-signature-clear" variant="contained" onClick={clear}>Clear</button>
        </React.Fragment>
      )
    } else if (!_.isEmpty(value)) {
      return (
        <img src={value} alt="" />
      )
    } else {
      return (
        <button type="button" className="btn btn-primary btn-sm" onClick={getSignature}>Press here to sign</button>
      )
    }
  }

  return (
    <React.Fragment>
      <label className="form-label">{schema.title} {required && '*'}</label>
      <div className="card signature-panel">
        <div className="card-body">
          {renderSignature()}
        </div>
      </div>
      {(userRole == 'clinician' && role == 'clinician' && !_.isEmpty(value)) &&
        <>
          <br/><button type="button" className="btn btn-info btn-sm" onClick={() => {
              clearInformation('clinician');
            }}>Clear Clinician Information </button>
        </>
      }

      {(userRole == 'supervisor' && role == 'clinician' && !_.isEmpty(value)) &&
        <>
          <br/><button type="button" className="btn btn-info btn-sm" onClick={() => {
              clearInformation('supervisor');
            }}>Clear Supervisor Information </button>
        </>
      }
    </React.Fragment>
  )
}

export default SignatureComponent;